class UnauthenticatedError extends Error {
  constructor() {
    super("Unauthenticated");
    this.name = "UnauthenticatedError";
    this.message = "Acceso denegado";
  }
}

export default UnauthenticatedError;
